<template>
    <Modal :show="show" @close="close()" className="p-0 pb-5">

        <header class="feature coach2">
        </header>
        <div class="modal-main ml-4 mr-4 text-center">
           <h2>Booking your Microbiome Coach call</h2>
            <p>You can book your Microbiome Coach call once you have completed your questionnaires in the Discovery Portal and received your report. In your kit summary on the Coach tab, tick the box to acknowledge you have received your report and click the button for "Make appointment".
              A pop-up window will ask you to select a time zone and day, and then select a time, confirm and enter your details. Click schedule event when these details are complete. You will receive an email confirmation of your appointment time. If you have any difficulties or are unable to book in this way, please phone us on 1300 974 621 to book your appointment.</p>
        </div>

        <div class="modal-footer">
          <a @click.prevent="close" href="" class="btn btn-primary">Close</a>
          <!--<button class="btn plain" v-on:click="close"><em>Close</em></button>-->
        </div>

    </Modal>
</template>

<script>
import Modal from '@/components/models/Modal'
export default {
  name: 'ModalCoachInfo',
  extends: Modal,
  components: {
    Modal
  },
  computed: {
    enableSurveys: function () {
      // return true
      return process.env.ENABLE_SURVEYS === 'true' || false // .env by default are strings
    }
  }
}
</script>

<style scoped lang="scss">
  .modal-body {
      padding-bottom:1.5rem;
  }
  button {
    margin: 2rem auto 0;
  }

  .coach2{
    background: url(/static/modal/Coach-What-is-covered.jpg) no-repeat; background-size: cover;
  }

  .btn.plain.btn-booking {
      color: #3F9FCF;
      font-size:1.125rem;
  }

  .modal-main {
    h2 {
      font-family: Athelas;
      font-size:32px;
      color: #002e6e;
    }
    span{
      font-family: Roboto;
      font-size: 18px;
      line-height: 1.5rem;
      color: #457363
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/models/ModalCoachInfo.vue